module.exports = __webpack_public_path__ + "static/media/4_RoomControls_BedLight_HL.b9c5f0af.png";